import { useParams } from 'react-router-dom';

export function useParamsId(): string {
    const { id } = useParams();
    if (id === undefined) throw Error('No ID provided');
    return id;
}
